import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c00e288"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Simple Synth", -1))
const _hoisted_2 = { class: "waveform-selection" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "info-box-container" }
const _hoisted_5 = { class: "info-box" }
const _hoisted_6 = { class: "info-box empty-box" }
const _hoisted_7 = { class: "piano-container" }
const _hoisted_8 = { class: "piano-keyboard" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instruction-box" }, " Use the keyboard to play a note or chord \"A,S,W,D\" ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PianoKey = _resolveComponent("PianoKey")!
  const _component_VolumeSlider = _resolveComponent("VolumeSlider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waveforms, (type) => {
        return (_openBlock(), _createElementBlock("button", {
          key: type,
          onClick: ($event: any) => (
          _ctx.setWaveformType(type as 'sine' | 'square' | 'triangle' | 'sawtooth')
        ),
          class: _normalizeClass({ 'waveform-selected': _ctx.synth.waveformType === type })
        }, _toDisplayString(type), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.currentNote), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentNote ? _ctx.getFrequencyForLabel(_ctx.currentNote) : "N/A"), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, index) => {
          return (_openBlock(), _createBlock(_component_PianoKey, {
            key: index,
            note: note,
            playNote: _ctx.playNote,
            stopNote: _ctx.stopNote,
            isActive: _ctx.activeKeys[note.label]
          }, null, 8, ["note", "playNote", "stopNote", "isActive"]))
        }), 128))
      ]),
      _createVNode(_component_VolumeSlider, {
        initialVolume: _ctx.volume,
        onVolumeChange: _ctx.emitVolumeChange
      }, null, 8, ["initialVolume", "onVolumeChange"]),
      _hoisted_9
    ])
  ]))
}